import _curry1 from "./internal/_curry1.js";
import _identity from "./internal/_identity.js";
/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      const obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */

var identity =
/*#__PURE__*/
_curry1(_identity);

export default identity;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/identity.js
// module id = 225
// module chunks = 1